import { useContext } from "react";

import { AppConfigContext } from "../../../../core/configuration/Configuration";
import { useAuthorizedFetch } from "../../../../core/data-access/useAuthorizedFetch";
import { GetSingleTvSeriesResponse } from "./GetSingleTvSeriesResponse";
import { SearchTvSeriesEntriesRequest } from "./SearchTvSeriesEntriesRequest";
import { SearchTvSeriesEntriesResponse } from "./SearchTvSeriesEntriesResponse";
import { SuggestTvSeriesByTitleResponse } from "./SuggestTvSeriesByTitleResponse";

export const useCatalogueTvApi = () => {
    const appConfigContext = useContext(AppConfigContext);
    const { httpGet, httpPost } = useAuthorizedFetch();
    const baseUrl = `${appConfigContext.catalogueConfig.apiUrl}/tv-series/search`;

    const suggestTvSeriesByTitle = async (title: string): Promise<SuggestTvSeriesByTitleResponse> => {
        return httpGet<SuggestTvSeriesByTitleResponse>(`${baseUrl}/suggest`, { title });
    };

    const searchTvSeriesEntries = async (
        request: SearchTvSeriesEntriesRequest
    ): Promise<SearchTvSeriesEntriesResponse> => {
        return httpPost<SearchTvSeriesEntriesResponse>(`${baseUrl}`, request);
    };

    const getSingleTvSeries = async (tvSeriesId: string): Promise<GetSingleTvSeriesResponse> => {
        return httpGet<GetSingleTvSeriesResponse>(`${baseUrl}/${tvSeriesId}`);
    };

    return { suggestTvSeriesByTitle, searchTvSeriesEntries, getSingleTvSeries };
};
